'use client';

import { useEffect } from 'react';
import { isPortalBuild } from '../lib/appTarget';

export const ServiceWorkerRegister = () => {
  useEffect(() => {
    if (isPortalBuild || typeof window === 'undefined') {
      return;
    }

    if (!('serviceWorker' in navigator)) {
      return;
    }

    // Service Worker는 점진적 향상이라 등록 실패(sw.js 404·차단 등)해도 화면 동작을 유지한다 (WEB-P).
    try {
      void navigator.serviceWorker.register('/sw.js').catch(() => {});
    } catch {
      // 동기 throw(지원 판정과 등록 사이의 경합 등)도 무시한다.
    }
  }, []);

  return null;
};
